@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import io.github.jangalinski.pages.AboutPage as _io_github_jangalinski_pages_AboutPage
import io.github.jangalinski.pages.IndexPage as _io_github_jangalinski_pages_IndexPage
import io.github.jangalinski.pages.LinksPage as _io_github_jangalinski_pages_LinksPage
import io.github.jangalinski.pages._2014._09._19.CloneAllGithubReposOfAnOrganizationPage as _io_github_jangalinski_pages__2014__09__19_CloneAllGithubReposOfAnOrganizationPage
import io.github.jangalinski.pages._2014._09._23.RedirectGitRemotesPage as _io_github_jangalinski_pages__2014__09__23_RedirectGitRemotesPage
import io.github.jangalinski.pages._2014._09._30.StartingWithDropwizardPage as _io_github_jangalinski_pages__2014__09__30_StartingWithDropwizardPage
import io.github.jangalinski.pages._2014._10._19.OsxYosemitePage as _io_github_jangalinski_pages__2014__10__19_OsxYosemitePage
import io.github.jangalinski.pages._2014._12._08.StreamingFromDropboxPage as _io_github_jangalinski_pages__2014__12__08_StreamingFromDropboxPage
import io.github.jangalinski.pages._2014._12._29.EasyMysqlSetupWithDockerPage as _io_github_jangalinski_pages__2014__12__29_EasyMysqlSetupWithDockerPage
import io.github.jangalinski.pages._2015._02._28.DeploySpringbootAsWarPage as _io_github_jangalinski_pages__2015__02__28_DeploySpringbootAsWarPage
import io.github.jangalinski.pages._2015._07._27.ConvertFromCamelToSnakeCasePage as _io_github_jangalinski_pages__2015__07__27_ConvertFromCamelToSnakeCasePage
import io.github.jangalinski.pages._2015._10._05.BuzzwordClockPage as _io_github_jangalinski_pages__2015__10__05_BuzzwordClockPage
import io.github.jangalinski.pages._2016._03._25.MatchingCollectorPage as _io_github_jangalinski_pages__2016__03__25_MatchingCollectorPage
import io.github.jangalinski.pages._2016._04._05.IdeaUltimateOnOsxPage as _io_github_jangalinski_pages__2016__04__05_IdeaUltimateOnOsxPage
import io.github.jangalinski.pages._2016._09._15.AndTheWinnerIsPage as _io_github_jangalinski_pages__2016__09__15_AndTheWinnerIsPage
import io.github.jangalinski.pages._2016._10._06.OsxIdeaExternalEditorPage as _io_github_jangalinski_pages__2016__10__06_OsxIdeaExternalEditorPage
import io.github.jangalinski.site.components.layout.BlogLayout as _io_github_jangalinski_site_components_layout_BlogLayout

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Jan Galinski"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "io.github.jangalinski.site.components.layout.BlogLayout",
        ) { pageCtx, pageMethod -> 
            _io_github_jangalinski_site_components_layout_BlogLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages.initIndexPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages_IndexPage()
        }
        ctx.router.register(
            "/2014/09/19/clone-all-github-repos-of-an-organization",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._09._19.initCloneAllGithubReposOfAnOrganizationPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__09__19_CloneAllGithubReposOfAnOrganizationPage()
        }
        ctx.router.register(
            "/2014/09/23/redirect-git-remotes",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._09._23.initRedirectGitRemotesPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__09__23_RedirectGitRemotesPage()
        }
        ctx.router.register(
            "/2014/09/30/starting-with-dropwizard",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._09._30.initStartingWithDropwizardPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__09__30_StartingWithDropwizardPage()
        }
        ctx.router.register(
            "/2014/10/19/osx-yosemite",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._10._19.initOsxYosemitePage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__10__19_OsxYosemitePage()
        }
        ctx.router.register(
            "/2014/12/08/streaming-from-dropbox",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._12._08.initStreamingFromDropboxPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__12__08_StreamingFromDropboxPage()
        }
        ctx.router.register(
            "/2014/12/29/easy-mysql-setup-with-docker",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2014._12._29.initEasyMysqlSetupWithDockerPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2014__12__29_EasyMysqlSetupWithDockerPage()
        }
        ctx.router.register(
            "/2015/02/28/deploy-springboot-as-war",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2015._02._28.initDeploySpringbootAsWarPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2015__02__28_DeploySpringbootAsWarPage()
        }
        ctx.router.register(
            "/2015/07/27/convert-from-camel-to-snake-case",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2015._07._27.initConvertFromCamelToSnakeCasePage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2015__07__27_ConvertFromCamelToSnakeCasePage()
        }
        ctx.router.register(
            "/2015/10/05/buzzword-clock",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2015._10._05.initBuzzwordClockPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2015__10__05_BuzzwordClockPage()
        }
        ctx.router.register(
            "/2016/03/25/matching-collector",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2016._03._25.initMatchingCollectorPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2016__03__25_MatchingCollectorPage()
        }
        ctx.router.register(
            "/2016/04/05/idea-ultimate-on-osx",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2016._04._05.initIdeaUltimateOnOsxPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2016__04__05_IdeaUltimateOnOsxPage()
        }
        ctx.router.register(
            "/2016/09/15/and-the-winner-is",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2016._09._15.initAndTheWinnerIsPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2016__09__15_AndTheWinnerIsPage()
        }
        ctx.router.register(
            "/2016/10/06/osx-idea-external-editor",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages._2016._10._06.initOsxIdeaExternalEditorPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages__2016__10__06_OsxIdeaExternalEditorPage()
        }
        ctx.router.register(
            "/about",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages_AboutPage()
        }
        ctx.router.register(
            "/links",
            layoutId = "io.github.jangalinski.site.components.layout.BlogLayout",
            initRouteMethod = { ctx ->
                io.github.jangalinski.pages.initLinksPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_jangalinski_pages_LinksPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        io.github.jangalinski.site.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        io.github.jangalinski.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
